import React from 'react';
import { LISTING_HEAP_PAGE_AREA_IDS } from '../../../../constants';
import { getCreatorVerificationBadge } from '../../../../experimentation';
import { CreatorBadgeVariantA } from '../CreatorBadgeVariantA/CreatorBadgeVariantA';
import { CreatorBadgeVariantB } from '../CreatorBadgeVariantB/CreatorBadgeVariantB';
import { OrganizerTrustSignalInfo } from '../OrganizerTrustSignalInfo/OrganizerTrustSignalInfo';

export interface OrganiserListingPageProps {
    organizerName: string;
    organizerId: string;
    trustSignal?: React.ReactNode;
    signalType?: string;
    organizerAvatar?: string;
    pageArea?: string;
    isMobile?: boolean;
    showBadge?: boolean;
}

const OrganiserListingPage = ({
    organizerName,
    organizerAvatar,
    organizerId,
    pageArea,
    isMobile,
    showBadge,
    trustSignal,
    signalType,
}: OrganiserListingPageProps) => {
    const showVariantType =
        organizerName && showBadge ? getCreatorVerificationBadge() : 'control';

    return (
        <div data-testid="creator-signal-main-section">
            {showVariantType === 'control' && (
                <OrganizerTrustSignalInfo
                    organizerName={organizerName}
                    organizerAvatar={organizerAvatar}
                    organizerId={organizerId}
                    pageArea={
                        pageArea || LISTING_HEAP_PAGE_AREA_IDS.ORGANIZER_PANEL
                    }
                    trustSignal={trustSignal}
                    signalType={signalType}
                />
            )}

            {showVariantType === 'variant_a' && (
                <CreatorBadgeVariantA
                    organizerName={organizerName}
                    organizerAvatar={organizerAvatar}
                    organizerId={organizerId}
                    pageArea={
                        pageArea || LISTING_HEAP_PAGE_AREA_IDS.ORGANIZER_PANEL
                    }
                    isMobile={isMobile}
                    showBadge={showBadge}
                />
            )}

            {showVariantType === 'variant_b' && (
                <CreatorBadgeVariantB
                    organizerName={organizerName}
                    organizerAvatar={organizerAvatar}
                    organizerId={organizerId}
                    pageArea={
                        pageArea || LISTING_HEAP_PAGE_AREA_IDS.ORGANIZER_PANEL
                    }
                />
            )}
        </div>
    );
};

export default OrganiserListingPage;
